import {SxType} from "@baseTypes/sx/sxTypes";
import {SV_DARK, SV_LIGHT, SV_RADIUS_MD} from "@containers/singleVoyage/views/constants/theme";

export const sx: SxType = {
    root: {
        maxWidth: '100%',
        marginLeft: 'auto',
        marginRight: 'auto',
        overflowX: 'auto',
        padding: '3px',
        borderRadius: SV_RADIUS_MD,
        '.lightTheme &': {
            backgroundColor: SV_LIGHT.surfaceMuted,
        },
        '.darkTheme &': {
            backgroundColor: SV_DARK.surfaceMuted,
        },
        '&::-webkit-scrollbar': {
            height: '4px'
        },
        '& a': {
            textDecoration: 'none',
        }
    }
}
